import React from 'react'

function Card({ props }) {
    const { zones } = props;



    // // Component registry mapping component types to their corresponding React components
    // const componentRegistry = {
    //     'HeadingBlock': HeadingBlock,
    //     'CustomBlock': Card,
    //     'Column': Column
    //     // Add other components here as needed
    // };



    // const renderZoneComponents = () => {
    //     // Check if zones is defined and is an object
    //     if (zones && typeof zones === 'object') {
    //         // Find the first key in zones that contains "my-content"
    //         const zoneKey = Object.keys(zones).find(key => key.includes('my-content'));

    //         // If a matching key is found
    //         if (zoneKey) {
    //             const components = zones[zoneKey]; // Get components from the matching zone

    //             // Check if components is an array and not empty
    //             if (Array.isArray(components) && components.length > 0) {
    //                 // Map over each component and render them
    //                 return components.map((component, index) => {
    //                     const Component = componentRegistry[component.type]; // Find the corresponding React component in the componentRegistry
    //                     // Render the component with its props
    //                     return <Component key={index} {...component.props} />;
    //                 });
    //             }
    //         }
    //     }

    //     return null; // If zones is undefined or null, or no matching zone is found, return null
    // };




    return (
        <>
            <div className="w-full">
                <div className="bg-white rounded-lg p-2 transform hover:translate-y-2 hover:shadow-xl transition duration-300">
                    <figure className="mb-2">
                    </figure>
                    <div className="rounded-lg p-4 bg-purple-700 flex flex-col">
                        <div>
                            <h5 className="text-white text-2xl font-bold leading-none">
                                {props.description}
                            </h5>
                            <span className="text-xs text-gray-400 leading-none">{props.text}</span>
                        </div>
                        <div className="flex items-center">
                            <div className="text-lg text-white font-light">
                                {props.title}
                            </div>
                            <button href="/" className="rounded-full bg-purple-900 text-white hover:bg-white hover:text-purple-900 hover:shadow-xl focus:outline-none w-10 h-10 flex ml-auto transition duration-300">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="stroke-current m-auto">
                                    <line x1="12" y1="5" x2="12" y2="19"></line>
                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {/* <DropZone zone="my-content" />
            {renderZoneComponents()} */}
        </>
    )
}

export default Card